module.exports = {"RETRY_DELAY_IF_RATE_LIMITED":5000}


//////////////////
// WEBPACK FOOTER
// ./node_modules/airtable/lib/internal_config.json
// module id = 556
// module chunks = 0